import PDF from './pdf'
import { formatAccounting, capitalizeFirstLetter, getCurrentDateEnUsFormat } from '../lib/utils'

export default class StoreTransferPdf extends PDF {
  /**
   * Description
   * @param {import('jspdf').DocumentProperties} args
   */
  constructor(args = {}) {
    super()
    this.doc.setProperties({
      unit: 'mm',
      format: 'a4',
      ...args,
    })
    this.addFonts()
  }

  /**
   * Description
   * @param {boolean} [cancel]
   */
  __header() {
    const title = `${capitalizeFirstLetter(this.getStoreName())} Report`
    this.generateText({ fontSize: 24, text: title, coordinates: [65, 15], color: [55, 71, 79] })
    this.generateText({ fontSize: 12, text: getCurrentDateEnUsFormat(), coordinates: [100, 22] })
    this.doc.setFillColor('#CFD8DC')
    this.doc.line(15, 25, 195, 25, 'F')
  }

  /**
   * Description
   * @param {TransferData} subHeader
   * @returns {void}
   */
  __subHeader(subHeader) {
    const { date_range: dateRange } = subHeader || {}
    const [x, y] = [15, 40]
    const delimiter = ':'

    this.generateField({
      label: 'Date Range',
      value: dateRange,
      coordinates: [x, y + 10],
      delimiter,
    })
  }

  /**
   * Description
   * @param {{ totalAmount: number; }} params
   * @param {TransferItem[]} body
   * @returns {any}
   */
  __table(body) {
    this.doc.autoTable({
      head: [
        [{ content: '', colSpan: 4 }, { content: 'Amount', styles: { halign: 'center' }, colSpan: '3' }],
        [
          'Date',
          'Store',
          'Order No',
          'Status',
          { content: 'Transpo', styles: { halign: 'center' } },
          { content: 'Balance', styles: { halign: 'center' } },
          { content: 'Sub', styles: { halign: 'center' } },
        ],
      ],
      startY: 60,
      body,
      columnStyles: {
        0: { halign: 'center' },
        1: { halign: 'center' },
        2: { halign: 'center' },
        3: { halign: 'center' },
        4: { halign: 'right' },
        5: { halign: 'right' },
        6: { halign: 'right' },
      },
    })
  }

  /**
   * Description
   * @param {string} orderNo
   * @param {boolean} [cancel]=false
   * @returns {void}
   */
  __save(orderNo, cancel = false) {
    const name = `${this.getStoreName()}_receipt_${orderNo}_${new Date().getTime()}`
    this.doc.save(name)
  }

  /**
   * Description
   * @param {TransferData} data
   * @param {TransferItem[]} items
   * @param {boolean} [cancel]
   * @returns {any}
   */
  generate(data, items) {
    this.__header()
    this.__subHeader(data)
    this.__table(items)
    this.__save(data.receiptNo)
  }
}

/**
 * @typedef TransferData
 * @property {number} date_range
 * 
 * @typedef {[string, string, string, string, string, string, string]} TransferItem
 * 
 * @type {TransferItem}
 * @example
 * [Date, Store, Order No, Status, Cost of Transport, Balance, Subtotal]
 */
